import { PageContentContainer } from './styles';

export default PageContentContainer;
